import {
  FlatList,
  Image,
  ScrollView,
  Text,
  TextInput,
  TouchableHighlight,
  TouchableOpacity,
  TouchableWithoutFeedback,
  View,
} from "react-native";
import React, { useEffect, useRef, useState } from "react";
import { AppColors } from "../../../utility/AppColors";
import { AppFontStyle } from "../../../styles/AppFontStyle";
import { getLoginData } from "../../../utility/AppStoreData";
import { Picker } from "@react-native-picker/picker";
import { AppImages } from "../../../utility/AppImages";
import DateTimePickerModal from "../WebScreens/Common/DateTimePickerModal";
import dayjs from "dayjs";
import { StackActions } from "@react-navigation/native";
import { navigateToScreen } from "../../../utility/NavigationHelper";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import * as ImagePicker from "expo-image-picker";
import { AppScreens } from "../../Utility/AppScreens";
import { toast } from "react-toastify";
import CompetitorsModal from "../WebScreens/CreateEvents/CompetitorsModal";
import { s } from "react-native-size-matters";
import { SwitchCommon } from "../../../common/SwitchCommon";
import { BeltImages } from "../../../Api/configs";
import { MobileDeviceNavigationHeader } from "../WebScreens/Common/MobileDeviceNavigationHeader";
import { fetchUserBalance } from "../../../services/profileAPI";
import { handleApiError } from "../../../services/errorHandler";
import { fetchGenreGames, uploadToS3 } from "../../../services/authAPI";
import SelectDropdown from "react-native-select-dropdown";
import Icon from "react-native-vector-icons/MaterialCommunityIcons";
import CornfirmPurchaseBeltModal from "../WebScreens/BeltScreens/CornfirmPurchaseBeltModal";
import { CommonButton } from "../../../common/CommonButton";
import CreateEventTooltip from "../../../Components/home-common-components/CreateEventTooltip";
import StreamingAccountModal from "../WebScreens/CreateEvents/StreamingAccountModal";
import ConnetedPopup from "../WebScreens/CreateEvents/ConnetedPopup";
import { useTooltips } from "../../../context/WalkthroughContext";
import Tooltip from "react-native-walkthrough-tooltip";
import NoBalancePopup from "../WebScreens/CreateEvents/NoBalancePopup";
import PrivateEventCreateComponent from "../../../Components/create-event-components/PrivateEventCreateComponent";
import { fetchEventDetails, updateEvent } from "../../../services/eventsAPI";
import Header from "../WebScreens/Common/Header";
export enum enumAddEditPublicPrivateScreen {
  Add = "Add",
  Edit = "Edit",
}

interface EventData {
  title: string;
  stakeType?: string;
  ticketPrice: number;
  playType?: string;
  gameTitle: string;
  startDateTime?: string;
  endDateTime?: string;
  duration?: number;
}

export default function UpdatePrivateEventScreen({ route, navigation }) {
  const styles = useStyles();
  const deviceSize = useDeviceSize();
  const [cornfirmPurchaseBeltModal, setCornfirmPurchaseBeltModal] =
    useState(false);
  const [beltPurchaseSuccessModal, setBeltPurchaseSuccessModal] =
    useState(false);
  const [dateTimeInput, setDateTimeInput] = useState("");
  const [eventName, setEventName] = useState("");
  const [selectStake, setSelectStake] = useState("Token");
  const [amount, setAmount] = useState("");
  const [userData, setUserData] = useState(null);
  const [tooltipForGift, setTooltipForGift] = useState(false);

  const [showDatePicker, setShowDatePicker] = useState(false);
  const [selectDate, setSelectDate] = useState("");
  const [selectTime, setSelectTime] = useState("");
  const [duration, setDuration] = useState("");
  const [playType, setPlayType] = useState("Competitive");
  const [gameType, setGameType] = useState("Fortnite");
  const [eventType, setEventType] = useState("");
  const [selectGame, setSelectGame] = useState("");
  const [ticketSystem, setTicketSystem] = useState("Token");
  const [ticketPrice, setTicketPrice] = useState("");
  const [competitorModel, setCompetitorModel] = useState(false);
  const [accessToken, setAccessToken] = useState("");
  const [apiData, setApiData] = useState<EventData>({
    title: "",
    stakeType: undefined,
    ticketPrice: 0,
    playType: undefined,
    gameTitle: "",
    startDateTime: undefined,
    endDateTime: undefined,
    duration: undefined,
  });

  const [refreshAPICall, setRefreshAPICall] = useState(false);
  const [description, setDescription] = useState("");
  const [gameID, setGameID] = useState("");
  const [gamerID, setGamerID] = useState("");
  const [device, setDevice] = useState("");
  const [challengeMode, setChallengeMode] = useState("1 VS 1");

  const [esquadifiSwitch, setEsquadifiSwitch] = useState(false);
  const [youTubeSwitch, setYouTubeSwitch] = useState(false);
  const [twitchSwitch, setTwitchSwitch] = useState(false);

  const [showLoader, setShowLoader] = useState(false);
  const [userBalanceData, setUserBalanceData] = useState(null);
  const [tooltipVisible, setTooltipVisible] = useState(false);

  const [chatSwitch, setChatSwitch] = useState(false);
  const [commentsSwitch, setCommentsSwitch] = useState(false);
  const [allOrNothingSwitch, setAllOrNothingSwitch] = useState(false);

  const [tokenTicket, setTokenTicket] = useState(50);
  const [hours, setHours] = useState(2);
  const [size, setSize] = useState(1);
  const [anticipatedCost, setAnticipatedCost] = useState(0);
  const [minAttendees, setMinAttendees] = useState(0);
  const tokenRate = 0.99 / 65;
  const [fileContent, setFileContent] = useState(null);
  const [fileName, setFileName] = useState(null);
  const [minTooltipVisible, setMinTooltipVisible] = useState(false);
  const [tooltipForEsquadifi, setTooltipForEsquadifi] = useState(false);
  const [anticipatedTooltipVisible, setAnticipatedTooltipVisible] =
    useState(false);
  const handleTokenTicketChange = (value) => {
    const numericValue = parseInt(value);
    if (!isNaN(numericValue) && numericValue >= 0) {
      setTokenTicket(numericValue);
    }
  };

  const handleDurationChange = (value) => {
    const numericValue = parseInt(value);
    if (!isNaN(numericValue) && numericValue >= 1 && numericValue <= 24) {
      setHours(numericValue);
    }
  };
  const handleSizeChange = (value) => {
    const numericValue = parseInt(value);
    if (!isNaN(numericValue) && numericValue >= 1 && numericValue <= 24) {
      setSize(numericValue);
    }
  };

  const calculateValues = () => {
    const cost = hours * 15000;
    setAnticipatedCost(cost);

    const minAttendeesValue = Math.ceil(cost / tokenTicket);
    setMinAttendees(minAttendeesValue);
  };

  React.useEffect(() => {
    calculateValues();
  }, [tokenTicket, hours]);
  const [balancePopup, setBalancePopup] = useState(false);
  const [arrDetermineStakes, setArrDetermineStakes] = useState([
    {
      id: 1,
      value: 0,
      name: "Bronze",
      numberOfSteaks: 0,
      image: BeltImages.Bronze,
      isSelected: 0,
      isAvailableAmountSelected: 1,
      token: 65,
      width: 99,
      height: 79,
      popupIconWidth: 73,
    },
    {
      id: 2,
      value: 0,
      name: "Silver",
      numberOfSteaks: 0,
      image: BeltImages.Silver,
      isSelected: 0,
      isAvailableAmountSelected: 0,
      token: 650,
      width: 99,
      height: 79,
      popupIconWidth: 73,
    },
    {
      id: 3,
      value: 0,
      name: "Gold",
      numberOfSteaks: 0,
      image: BeltImages.Gold,
      isSelected: 0,
      isAvailableAmountSelected: 0,
      token: 6500,
      width: 99,
      height: 79,
      popupIconWidth: 73,
    },
    {
      id: 4,
      value: 0,
      name: "Platinum",
      numberOfSteaks: 0,
      image: BeltImages.Platinum,
      isSelected: 0,
      isAvailableAmountSelected: 0,
      token: 65000,
      width: 99,
      height: 79,
      popupIconWidth: 73,
    },
  ]);

  const [games, setGames] = useState([]);
  const [numberOfBelts, setNumberOfBelts] = useState("1");
  const getGenreGames = async () => {
    try {
      const response = await fetchGenreGames(); // Fetch the games data
      const responseBody =
        typeof response.body === "string"
          ? JSON.parse(response.body) // Parse the stringified JSON
          : response.body;

      if (response.statusCode === 200) {
        // Extract titles from the responseBody array
        const gamesList = responseBody.map((game) => game.title);
        console.log("gamesList = ", gamesList);

        setGames(gamesList); // Update the state with the list of titles
        setShowLoader(false); // Hide the loader
      } else {
        toast.error(responseBody.error); // Show error message
      }
    } catch (error) {
      console.error("get games API Error:- ", error.message);
      toast.error(error.message); // Show toast notification for errors
    }
  };
  useEffect(() => {
    getGenreGames();
  }, []);

  const checkUserBalanceAPI = async (accessTokenValue) => {
    setShowLoader(true);

    try {
      const response = await fetchUserBalance(accessTokenValue);
      setShowLoader(false);

      if (response) {
        setUserBalanceData(response.body);
        if (response?.body?.balance === 0) {
          setBalancePopup(true);
        }
        const belts = response.body?.belts;

        const arr = [...arrDetermineStakes];

        // Only process belts if they exist
        if (belts) {
          arr.map((item) => {
            if (item.name === "Bronze") item.value = Number(belts.bronze || 0);
            else if (item.name === "Silver")
              item.value = Number(belts.silver || 0);
            else if (item.name === "Gold") item.value = Number(belts.gold || 0);
            else if (item.name === "Platinum")
              item.value = Number(belts.platinum || 0);
          });
        }
        setArrDetermineStakes(arr);
        setRefreshAPICall(false);
      } else {
        handleApiError(response.status, response.error);
        setRefreshAPICall(false);
      }
    } catch (error) {
      setShowLoader(false);
      setRefreshAPICall(false);
      toast.error(error.message);
    }
  };

  useEffect(() => {
    getLoginUserData((data) => {
      checkUserBalanceAPI(data.AccessToken);
    });
  }, [refreshAPICall]);

  const pickImage = async () => {
    // No permissions request is necessary for launching the image library
    let result = await ImagePicker.launchImageLibraryAsync({
      mediaTypes: ImagePicker.MediaTypeOptions.Images,
      allowsEditing: true,
      aspect: [4, 3],
      quality: 1,
    });

    console.log(result);

    if (!result.canceled) {
      setFileName(result.assets[0].fileName);
      setFileContent(result.assets[0].uri);
    }
  };

  async function getLoginUserData(success) {
    const data = await getLoginData();

    // console.log("load aapppp data: -----> ", data);
    if (data != null) {
      setUserData(data);
      setAccessToken(data.AccessToken);
      console.log("userData ====>: ", data.AccessToken);
      // console.log('Response in string : - ', JSON.parse(JSON.stringify(data)))
      // console.log('Response in JSON : - ', JSON.parse(data))
      success(data);
    }
  }

  const calculateStakeAmountValue = () => {
    const beltWithSteaks = arrDetermineStakes.find(
      (item) => item.numberOfSteaks > 0
    );

    return beltWithSteaks ? beltWithSteaks.numberOfSteaks : 0;
  };

  const generateRandomString = (length = 6) => {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    const charactersLength = characters.length;

    while (result.length < length) {
      const randomIndex = Math.floor(Math.random() * charactersLength);
      result += characters.charAt(randomIndex);
    }
    return result;
  };
  const callUploadToS3API = async (fileName, fileContent) => {
    const randomUsername = generateRandomString(6);
    const bodyParams = {
      bucketName: "squdifi-event-thumbnail",
      fileName: fileName,
      fileContent: fileContent,
      username: randomUsername,
    };

    try {
      const response = await uploadToS3(bodyParams);

      if (response.statusCode === 200 || response.statusCode === 201) {
        if (response.body) {
          const profilePicture = response.body.fileUrl;

          toast.success(response.body.message);
          return profilePicture;
        }
      } else {
        handleApiError(response.statusCode, response.body?.error || "");
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  async function checkValidation() {
    const stakeAmountValue = calculateStakeAmountValue();

    if (eventName === "") {
      toast.error("Please enter event name");
    } else if (gamerID === "") {
      toast.error("Please enter Gamer ID");
    } else if (description === "") {
      toast.error("Please enter description");
    } else if (stakeAmountValue === 0) {
      toast.error("You didn't have selected belts, Please first select belt");
    } else if (selectDate === "") {
      toast.error("Please select date");
    } else if (selectTime === "") {
      toast.error("Please select time");
    } else if (selectGame === "") {
      toast.error("Please select game");
    } else if (!youTubeSwitch && !twitchSwitch) {
      toast.error("You must enable either YouTube or Twitch streaming.");
    } else if (youTubeSwitch && twitchSwitch) {
      toast.error(
        "You cannot enable both YouTube and Twitch streaming at the same time."
      );
    } else {
      const date = new Date(dateTimeInput);

      const date1 = dayjs(date).add(parseInt(duration), "hours");
      const formatedEndDate = dayjs(date1).format("YYYY-MM-DDTHH:mm:ss[Z]");

      const organiserID = userData?.username || "";

      const stakeAmount = arrDetermineStakes
        .filter((item) => item.numberOfSteaks > 0)
        .map((item) => item.numberOfSteaks)
        .join(", ");
      const stakeType = arrDetermineStakes
        .filter((item) => item.numberOfSteaks > 0)
        .map((item) => item.name)
        .join(", ");

      const eventData = {
        challengeMode,
        title: eventName,
        selectGame,
        gamerID,
        device,
        description,
        type: eventType,
        gameTitle: gameType,
        organiserID,
        playType,
        ticketPrice: tokenTicket,
        determineTheStakesValue: stakeAmountValue,
        stakeAmount,
        stakeType,
        size,
        hours,
        startDateTime: dateTimeInput,
        endDateTime: formatedEndDate,
        liveStreamWithYoutube: youTubeSwitch,
        liveStreamWithEsquadifi: esquadifiSwitch,
        liveStreamWithTwitch: twitchSwitch,
        organiserPercentage: organiserAmount,
        challengerPercentage: challengerAmount,
        chatSwitch,
        allOrNothingSwitch,
      };

      if (fileContent && fileName) {
        eventData.fileContent = fileContent;
        eventData.fileName = fileName;
      }

      await callUpdateEventAPI(eventData);
    }
  }

  async function callUpdateEventAPI(eventData) {
    setShowLoader(true); // Show loader while the API call is in progress

    const bodyParams = {
      accessToken,
      eventID: route.params.eventID,
      newDetails: eventData,
    };

    try {
      const response = await updateEvent(bodyParams);

      setShowLoader(false);

      if (response.statusCode === 200 || response.statusCode === 201) {
        toast.success(response.body?.message || "Event updated successfully");
        navigateToScreen(navigation, AppScreens.OnGoingEvents, {
          eventID: route.params.eventID,
        });
        await getEventDetails(route.params.eventID);
      } else {
        handleApiError(
          response.statusCode,
          response.body?.error || "Update failed"
        );
      }
    } catch (error) {
      setShowLoader(false);
      toast.error(
        error.message || "An error occurred while updating the event"
      );
    }
  }
  const [organiserAmount, setOrganiserAmount] = useState(50); // Kaller Percentage
  const [challengerAmount, setChallengerAmount] = useState(50); // Challenger Percentage

  const handleOrganiserAmountChange = (value) => {
    const numericValue = parseInt(value);
    if (!isNaN(numericValue) && numericValue >= 0 && numericValue <= 100) {
      setOrganiserAmount(numericValue);
      setChallengerAmount(100 - numericValue);
    }
  };

  const handleChallengerAmountChange = (value) => {
    const numericValue = parseInt(value);
    if (!isNaN(numericValue) && numericValue >= 0 && numericValue <= 100) {
      setChallengerAmount(numericValue);
      setOrganiserAmount(100 - numericValue);
    }
  };

  const [isOpen, setIsOpen] = useState(false);
  const [openChild, setOpenChild] = useState(null);

  const handleOutsideClick = () => {
    if (tooltipVisible) {
      setTooltipVisible(false);
    }
    if (minTooltipVisible) {
      setMinTooltipVisible(false);
    }
    if (anticipatedTooltipVisible) {
      setAnticipatedTooltipVisible(false);
    }
    if (tooltipForEsquadifi) {
      setTooltipForEsquadifi(false);
    }
    if (tooltipForGift) {
      setTooltipForGift(false);
    }
    if (showYoutubePopup) {
      setShowYoutubePopup(false);
    }
    if (showTwitchPopup) {
      setShowTwitchPopup(false);
    }
    if (connectedPopup) {
      setConnectedPopup(false);
    }
  };

  const [showYoutubePopup, setShowYoutubePopup] = useState(false);
  const [showTwitchPopup, setShowTwitchPopup] = useState(false);
  const [connectedPopup, setConnectedPopup] = useState(false);
  const handleSwitchToggle = (value) => {
    setYouTubeSwitch(value);
    // if (value) {
    //   setShowYoutubePopup(true);
    // }
  };
  const handleTwitchSwitchToggle = (value) => {
    setTwitchSwitch(value);
    // if (value) {
    //   setShowTwitchPopup(true);
    // }
  };
  const closePopup = () => {
    if (showYoutubePopup) {
      setShowYoutubePopup(false);
    }
    if (showTwitchPopup) {
      setShowTwitchPopup(false);
    }
  };

  useEffect(() => {
    if (connectedPopup) {
      closePopup();
    }
  }, [connectedPopup]);
  const {
    eventNameTooltipVisible,
    setEventNameTooltipVisible,
    gameTooltipVisible,
    setGameTooltipVisible,
    deviceTooltipVisible,
    setDeviceTooltipVisible,
    gamerIdTooltipVisible,
    setGamerIdTooltipVisible,
    descriptionTooltipVisible,
    setDescriptionTooltipVisible,
    stakeTooltipVisible,
    setStakeTooltipVisible,
    dateTimeTooltipVisible,
    setDateTimeTooltipVisible,
    exclusiveTooltipVisible,
    setExclusiveTooltipVisible,
    settingTooltipVisible,
    setSettingTooltipVisible,
    resetCreateEventTooltips,
    currentStep,
    totalSteps,
    setTotalSteps,
    handleNextStep,
  } = useTooltips();
  if (eventNameTooltipVisible) {
    setTotalSteps(9);
  }
  const scrollViewRef = useRef(null);
  const handleNextStepFromGamerIdTooltip = () => {
    // Scroll to a specific position in the ScrollView
    scrollViewRef.current?.scrollTo({ y: 400, animated: true }); // Adjust 'y' as per your layout

    // Hide the organised tooltip and show the upcoming event tooltip
    setTimeout(() => {
      setDescriptionTooltipVisible(true);
    }, 500);
  };
  const handleNextStepFromDateTimeTooltip = () => {
    // Scroll to a specific position in the ScrollView

    scrollViewRef.current?.scrollToEnd({ animated: true });
    // Hide the organised tooltip and show the upcoming event tooltip
    setTimeout(() => {
      setExclusiveTooltipVisible(true);
    }, 500);
  };

  const handleErrorResponse = (statusCode, errorMessage) => {
    if (statusCode === 400) {
      toast.error("Bad Request");
    } else if (statusCode > 400 && statusCode < 420) {
      toast.error("Unauthorized");
    } else if (statusCode >= 500) {
      toast.error("Internal Server Error");
    } else {
      toast.error(errorMessage);
    }
    navigateToScreen(navigation, AppScreens.Home);
  };

  useEffect(() => {
    if (route.params.eventID) {
      getEventDetails(route.params.eventID);
    }
  }, [route.params.eventID]);

  const getEventDetails = async (eventID) => {
    setShowLoader(true);
    const userData = await getLoginData();
    try {
      const data = await fetchEventDetails(eventID, userData.AccessToken);

      if (data) {
        setEventName(data.title);
        setDescription(data.description);
        setSelectDate(dayjs(data.startDateTime).format("DD/MM/YYYY"));
        setSelectTime(dayjs(data.startDateTime).format("HH:mm"));
        setGameType(data.gameTitle);
        setSelectGame(data.gameSearchTerm);
        setGamerID(data.gamerID);
        setDevice(data.device);
        setYouTubeSwitch(data.liveStreamWithYoutube);
        setTwitchSwitch(data.liveStreamWithTwitch);
        setEsquadifiSwitch(data.liveStreamWithEsquadifi);
        setChatSwitch(data.chat);
        setAllOrNothingSwitch(data.allOrNothing);
        setFileContent(data?.eventPicUrl);
        setOrganiserAmount(data.organiserPercentage);
        setChallengerAmount(data.challengerPercentage);
        setDateTimeInput(data.startDateTime);
        setHours(data.hours ? data.hours : 0);
        setSize(data.size ? data.size : 0);
        setTokenTicket(data.ticketPrice);
        setEventType(data.type);
        const updatedStakes = arrDetermineStakes.map((item) => {
          const stakeTypes = data.stakeType
            .split(",")
            .map((type) => type.trim().toLowerCase());
          const stakeAmounts = data.stakeAmount
            .split(",")
            .map((amount) => Number(amount.trim()));

          const stakeIndex = stakeTypes.findIndex(
            (type) => type === item.name.toLowerCase()
          );

          if (stakeIndex !== -1) {
            return { ...item, numberOfSteaks: stakeAmounts[stakeIndex] || 0 };
          }

          return item;
        });

        setArrDetermineStakes(updatedStakes);
        // setDetails(data);

        // const attendeeIDs = data.attendeeIDs || [];
        // const newUsersData = attendeeIDs.map(
        //   (username: String, index: any) => ({
        //     id: index + 1,
        //     username: username,
        //     userImage: AppImages.icApple,
        //   })
        // );

        // setUsersData(newUsersData);
      } else {
        handleErrorResponse(data.statusCode, data.body.error);
      }
    } catch (error) {
      toast.error("Error fetching event");
      navigateToScreen(navigation, AppScreens.Home);
    } finally {
      setShowLoader(false);
    }
  };

  return (
    <TouchableWithoutFeedback onPress={handleOutsideClick}>
      <View style={[styles.container]}>
        {/* {deviceSize === DEVICE_SIZES.XS ? (
          <MobileDeviceNavigationHeader
            btnNotificationTapped={() => {
              console.log("btnNotificationTapped");
              navigateToScreen(navigation, AppScreens.NotificationScreen
                  // { txtSearch: searchEvent });
            }}
            btnSettingTapped={() => {
              console.log("btnSettingTapped");
              navigateToScreen(navigation, AppScreens.SettingWebScreen
                  // { txtSearch: searchEvent });
            }}
            btnSearchTapped={() => {
              console.log("btnSearchTapped");
              navigateToScreen(navigation, AppScreens.SearchEventWebScreen
                  // { txtSearch: searchEvent });
            }}
          />
        ) : null} */}
        <Header
          btnSearchTapped={() => {
            navigateToScreen(navigation, AppScreens.SearchEventWebScreen);
          }}
          btnWalletTapped={() => {}}
          btnStartTutorialTapped={() => {}}
          btnMessageTapped={() => {}}
          btnNotificationTapped={() => {}}
          btnProfileTapped={() => {}}
        />
        <View style={[styles.mainView]}>
          <View>
            <View
              style={{
                flexDirection: "row",
                justifyContent: "space-between",
                marginTop:
                  deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE ? 40 : 20,
              }}
            >
              {/* Update Event */}
              <Text
                style={[
                  deviceSize === DEVICE_SIZES.EXTRA_LARGE_DEVICE
                    ? AppFontStyle.BOLD_ANYBODY_32
                    : AppFontStyle.BOLD_ANYBODY_20,
                  {
                    color: AppColors.white,
                    alignSelf: "center",
                  },
                ]}
              >
                {(route.params.checkScreen || "Add") ===
                enumAddEditPublicPrivateScreen.Add
                  ? "Update Event"
                  : "Edit Event"}
              </Text>
              {deviceSize !== DEVICE_SIZES.XS ? (
                <TouchableOpacity
                  style={{
                    backgroundColor: AppColors.appViolentColor_6D08C3,
                    borderRadius: 10,
                    justifyContent: "center",
                    alignItems: "center",
                    width: 170,
                    height: 39,
                    marginHorizontal: 10,
                  }}
                  onPress={() => {
                    setEventNameTooltipVisible(true);
                  }}
                >
                  <Text
                    style={[
                      AppFontStyle.BOLD_ANYBODY_18,
                      {
                        paddingVertical: 8,
                        paddingHorizontal: 15,
                        color: AppColors.white,
                      },
                    ]}
                  >
                    Start tutorial
                  </Text>
                </TouchableOpacity>
              ) : null}
            </View>
            <View style={styles.divider} />
          </View>

          <ScrollView showsVerticalScrollIndicator={false} ref={scrollViewRef}>
            <PrivateEventCreateComponent
              styles={styles}
              challengeMode={challengeMode}
              arrDetermineStakes={arrDetermineStakes}
              setArrDetermineStakes={setArrDetermineStakes}
              eventNameTooltipVisible={eventNameTooltipVisible}
              totalSteps={totalSteps}
              currentStep={currentStep}
              setEventNameTooltipVisible={setEventNameTooltipVisible}
              setGameTooltipVisible={setGameTooltipVisible}
              handleNextStep={handleNextStep}
              setEventName={setEventName}
              eventName={eventName}
              numberOfBelts={numberOfBelts}
              setNumberOfBelts={setNumberOfBelts}
              setCornfirmPurchaseBeltModal={setCornfirmPurchaseBeltModal}
              gameTooltipVisible={gameTooltipVisible}
              setDeviceTooltipVisible={setDeviceTooltipVisible}
              games={games}
              setSelectGame={setSelectGame}
              selectGame={selectGame}
              allOrNothingSwitch={allOrNothingSwitch}
              setAllOrNothingSwitch={setAllOrNothingSwitch}
              tooltipForGift={tooltipForGift}
              setTooltipForGift={setTooltipForGift}
              chatSwitch={chatSwitch}
              setChatSwitch={setChatSwitch}
              resetCreateEventTooltips={resetCreateEventTooltips}
              settingTooltipVisible={settingTooltipVisible}
              twitchSwitch={twitchSwitch}
              handleTwitchSwitchToggle={handleTwitchSwitchToggle}
              youTubeSwitch={youTubeSwitch}
              handleSwitchToggle={handleSwitchToggle}
              esquadifiSwitch={esquadifiSwitch}
              setEsquadifiSwitch={setEsquadifiSwitch}
              tooltipForEsquadifi={tooltipForEsquadifi}
              setTooltipForEsquadifi={setTooltipForEsquadifi}
              deviceTooltipVisible={deviceTooltipVisible}
              setGamerIdTooltipVisible={setGamerIdTooltipVisible}
              device={device}
              isOpen={isOpen}
              setDevice={setDevice}
              setIsOpen={setIsOpen}
              openChild={openChild}
              setOpenChild={setOpenChild}
              gamerID={gamerID}
              setGamerID={setGamerID}
              handleNextStepFromGamerIdTooltip={
                handleNextStepFromGamerIdTooltip
              }
              descriptionTooltipVisible={descriptionTooltipVisible}
              setDescriptionTooltipVisible={setDescriptionTooltipVisible}
              setStakeTooltipVisible={setStakeTooltipVisible}
              tooltipVisible={tooltipVisible}
              setTooltipVisible={setTooltipVisible}
              description={description}
              setDescription={setDescription}
              pickImage={pickImage}
              fileContent={fileContent}
              stakeTooltipVisible={stakeTooltipVisible}
              setDateTimeTooltipVisible={setDateTimeTooltipVisible}
              handleOrganiserAmountChange={handleOrganiserAmountChange}
              organiserAmount={organiserAmount}
              handleChallengerAmountChange={handleChallengerAmountChange}
              challengerAmount={challengerAmount}
              dateTimeTooltipVisible={dateTimeTooltipVisible}
              handleNextStepFromDateTimeTooltip={
                handleNextStepFromDateTimeTooltip
              }
              setShowDatePicker={setShowDatePicker}
              setSelectDate={setSelectDate}
              selectDate={selectDate}
              selectTime={selectTime}
              setSelectTime={setSelectTime}
              handleSizeChange={handleSizeChange}
              size={size}
              setSize={setSize}
              handleDurationChange={handleDurationChange}
              hours={hours}
              setHours={setHours}
              anticipatedTooltipVisible={anticipatedTooltipVisible}
              setAnticipatedTooltipVisible={setAnticipatedTooltipVisible}
              anticipatedCost={anticipatedCost}
              tokenRate={tokenRate}
              handleTokenTicketChange={handleTokenTicketChange}
              tokenTicket={tokenTicket}
              setTokenTicket={setTokenTicket}
              minTooltipVisible={minTooltipVisible}
              setMinTooltipVisible={setMinTooltipVisible}
              minAttendees={minAttendees}
              exclusiveTooltipVisible={exclusiveTooltipVisible}
              setExclusiveTooltipVisible={setExclusiveTooltipVisible}
              setSettingTooltipVisible={setSettingTooltipVisible}
              gamerIdTooltipVisible={gamerIdTooltipVisible}
            />
            {/* Back & Next Buttons  */}
            <View
              style={{
                width:
                  deviceSize === DEVICE_SIZES.XS ||
                  deviceSize === DEVICE_SIZES.SM ||
                  deviceSize === DEVICE_SIZES.MD
                    ? "100%"
                    : "80%",
              }}
            >
              <View
                style={{
                  justifyContent: "flex-end",
                  flexDirection: "row",
                  marginTop: 20,
                  gap: 10,
                  // height: 38,
                }}
              >
                {/* Back Button */}
                <TouchableOpacity
                  style={{
                    width: 146,
                    borderRadius: 10,
                    marginBottom: 15,
                    justifyContent: "center",
                    alignItems: "center",
                    borderWidth: 2,
                    borderColor: AppColors.appViolentColor_6D08C3,
                  }}
                  onPress={() => {
                    navigation.dispatch(StackActions.pop());
                  }}
                >
                  <Text
                    style={[
                      AppFontStyle.BOLD_ANYBODY_12,
                      {
                        paddingVertical: 12,
                        paddingHorizontal: 40,
                        color: AppColors.white,
                      },
                    ]}
                  >
                    Back
                  </Text>
                </TouchableOpacity>
                {/* Next Button */}
                <TouchableOpacity
                  style={{
                    // width: 146,
                    backgroundColor: AppColors.appViolentColor_6D08C3,
                    borderRadius: 10,
                    marginBottom: 15,
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  onPress={() => {
                    checkValidation();
                  }}
                >
                  <Text
                    style={[
                      AppFontStyle.BOLD_ANYBODY_12,
                      {
                        paddingVertical: 8,
                        paddingHorizontal: 40,
                        color: AppColors.white,
                      },
                    ]}
                  >
                    Save Changes
                  </Text>
                </TouchableOpacity>
              </View>
            </View>
          </ScrollView>
        </View>

        {showYoutubePopup && (
          <StreamingAccountModal
            showPopup={showYoutubePopup}
            closePopup={closePopup}
            image={AppImages.icYoutubeStreaming}
            connected={false}
          />
        )}
        {showTwitchPopup && (
          <StreamingAccountModal
            showPopup={showTwitchPopup}
            closePopup={closePopup}
            image={AppImages.twitchStream}
            connected={true}
          />
        )}

        {connectedPopup && (
          <ConnetedPopup
            showPopup={connectedPopup}
            closePopup={() => setConnectedPopup(false)}
          />
        )}

        {showDatePicker && (
          <DateTimePickerModal
            showModal={showDatePicker}
            setShowModal={setShowDatePicker}
            selectedDate={(date) => {
              console.log("selectedDate: ", date);

              const formattedDate = dayjs(date).toISOString();
              console.log("Formatted Date: ", formattedDate);
              setDateTimeInput(formattedDate);
              setSelectDate(dayjs(date).format("DD/MM/YYYY"));
              setSelectTime(dayjs(date).format("HH:mm"));
            }}
            timePicker={true}
          />
        )}
        {cornfirmPurchaseBeltModal && (
          <CornfirmPurchaseBeltModal
            accessToken={accessToken}
            showModal={cornfirmPurchaseBeltModal}
            userBalanceData={userBalanceData}
            setShowModal={setCornfirmPurchaseBeltModal}
            setRefreshAPICall={setRefreshAPICall}
            dataSelectedBelt={arrDetermineStakes.find(
              (item) => item.isAvailableAmountSelected
            )}
            numberOfBelts={numberOfBelts}
            selectedBelt={(data) => {
              console.log("Selected CornfirmPurchaseBeltModal:- ", data);
              setBeltPurchaseSuccessModal(true);
              // setShowPaymentScreen(true);
            }}
            jumbToPurchaseToken={(isNavigate: false) => {
              console.log("jumbToPurchaseToken:- ", isNavigate);
              if (isNavigate) {
                navigateToScreen(navigation, AppScreens.PurchaseScreen);
              }
            }}
          />
        )}

        {competitorModel && (
          <CompetitorsModal
            showModal={competitorModel}
            setShowModal={setCompetitorModel}
            apiData={apiData}
            setApiData={setApiData}
            accessToken={accessToken}
            setRefreshAPICall={setRefreshAPICall}
            isUpdate={true}
            eventID={route.params.eventData.eventID}
          />
        )}

        {balancePopup && (
          <NoBalancePopup
            showPopup={balancePopup}
            closePopup={() => setBalancePopup(false)}
          />
        )}
      </View>
    </TouchableWithoutFeedback>
  );
}

const useStyles = CreateResponsiveStyle(
  {
    deviceflexDirection: {
      flexDirection: "row",
    },
    viewStyle: {
      width: "30%",
    },
    container: {
      flex: 1,
      backgroundColor: AppColors.black_121212,
    },
    mainView: {
      flex: 1,
      paddingHorizontal: 40,
      marginHorizontal: 30,
    },
    divider: {
      height: 2,
      marginTop: 16,
      backgroundColor: AppColors.appGrayColor_1C1C1C,
      width: "100%",
    },
    headerTitle: {
      color: AppColors.white,
      paddingTop: 16,
    },
    lableStyle: {
      color: AppColors.gray_C3C3C3,
      paddingTop: 14,
    },
    inputWrapper: {
      // flex: 1,
      backgroundColor: AppColors.appGrayColor_1C1C1C,
      paddingHorizontal: 12,
      borderRadius: 10,
    },
    textInputStyle: {
      paddingVertical: 18,
      paddingHorizontal: 10,
      color: AppColors.white,
      outlineStyle: "none",
    },
    leftWrapper: {
      width: 459,
      flexDirection: "column",
      gap: 12,
    },
    rightWrapper: {
      width: 459,
      flexDirection: "column",
      gap: 12,
    },
    dropDownStyle: {
      backgroundColor: AppColors.appGrayColor_1C1C1C,
      borderColor: AppColors.appGrayColor_1C1C1C,
      paddingVertical: 18,
      color: AppColors.white,
      outlineStyle: "none",
    },
    mainInputWrapper: {
      flexDirection: "row",
      gap: 20,
    },
    rightDurationWrapper: {
      width: "20%",
      flexDirection: "column",
      gap: 12,
    },
    gameWrapper: {
      width: "40%",
      flexDirection: "column",
      gap: 12,
    },

    challegeMode: {
      flexDirection: "row",
      justifyContent: "space-between",
    },
    dropdownButtonStyle: {
      width: "100%",
      height: 50,
      backgroundColor: AppColors.appGrayColor_1C1C1C,
      borderRadius: 12,
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
      paddingHorizontal: 12,
    },
    dropdownButtonTxtStyle: {
      flex: 1,
      color: AppColors.white,
    },
    dropdownButtonArrowStyle: {
      fontSize: 28,
      color: AppColors.white,
    },
    dropdownMenuStyle: {
      backgroundColor: AppColors.appGrayColor_1C1C1C,
      marginTop: 10,
    },
    dragDropView: {
      height: 105,
      backgroundColor: AppColors.appBlackColor_1e1e1e,
      borderRadius: 10,
      padding: 10,
      alignItems: "center",
      flexDirection: "row",
      justifyContent: "space-between",
      gap: 10,
    },
    dropdownItemStyle: {
      width: "100%",
      flexDirection: "row",
      paddingHorizontal: 12,
      justifyContent: "center",
      alignItems: "center",
      paddingVertical: 8,
    },
    dropdownItemTxtStyle: {
      flex: 1,
      fontSize: 18,
      fontWeight: "500",
      color: AppColors.white,
    },
    searchInputStyle: {
      height: 40,
      marginTop: 10,
      fontSize: 16,
      paddingHorizontal: 10,
      backgroundColor: AppColors.appGrayColor_1C1C1C,
    },
    searchTextStyle: {
      color: AppColors.white,
    },
    buyBeltButtonStyle: {
      paddingVertical: 14,
      backgroundColor: AppColors.appViolentColor_6D08C3,
      borderRadius: 10,
      shadowOpacity: 0,
      width: 132,
      flex: 1,
    },
    inputText: {
      width: 85,
      textAlign: "left",
      color: AppColors.white,
      outlineStyle: "none",
    },
  },
  {
    [DEVICE_SIZES.LG]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.black_121212,
      },
      mainView: {
        flex: 1,
        paddingHorizontal: 40,
        marginHorizontal: 30,
      },
      divider: {
        height: 2,
        marginTop: 16,
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        width: "100%",
      },
      headerTitle: {
        color: AppColors.gray_C3C3C3,
        paddingTop: 16,
      },
      lableStyle: {
        color: AppColors.gray_C3C3C3,
        paddingTop: 14,
      },
      inputWrapper: {
        flex: 1,
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        paddingHorizontal: 12,
        borderRadius: 10,
      },
      textInputStyle: {
        paddingVertical: 18,
        paddingHorizontal: 10,
        color: AppColors.white,
      },
      leftWrapper: {
        width: 459,
        flexDirection: "column",
        gap: 12,
      },
      rightWrapper: {
        width: 459,
        flexDirection: "column",
        gap: 12,
      },
      dropDownStyle: {
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        borderColor: AppColors.appGrayColor_1C1C1C,
        paddingVertical: 18,
        color: AppColors.white,
      },
      mainInputWrapper: {
        flexDirection: "row",
        gap: 20,
      },
      rightDurationWrapper: {
        width: "20%",
        flexDirection: "column",
        gap: 12,
      },
      gameWrapper: {
        width: "40%",
        flexDirection: "column",
        gap: 12,
      },

      challegeMode: {
        flexDirection: "column",
        justifyContent: "space-evenly",
        gap: 30,
        marginBottom: 20,
      },
      viewStyle: {
        width: "47%",
      },
    },
    [DEVICE_SIZES.MD]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.black_121212,
      },
      viewStyle: {
        width: "47%",
      },
      mainView: {
        flex: 1,
        paddingHorizontal: 25,
        marginHorizontal: 16,
      },
      divider: {
        height: 2,
        marginTop: 16,
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        width: "100%",
      },
      headerTitle: {
        color: AppColors.gray_C3C3C3,
        paddingTop: 16,
      },
      lableStyle: {
        color: AppColors.gray_C3C3C3,
        paddingTop: 14,
      },
      inputWrapper: {
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        paddingHorizontal: 12,
        borderRadius: 10,
      },
      textInputStyle: {
        paddingVertical: 18,
        paddingHorizontal: 10,
        color: AppColors.white,
      },
      leftWrapper: {
        width: "100%",
        flexDirection: "column",
        gap: 12,
      },
      rightWrapper: {
        width: "100%",
        flexDirection: "column",
        gap: 12,
      },
      dropDownStyle: {
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        borderColor: AppColors.appGrayColor_1C1C1C,
        paddingVertical: 18,
        color: AppColors.white,
      },
      mainInputWrapper: {
        flexDirection: "column",
        gap: 20,
      },
      rightDurationWrapper: {
        width: "20%",
        flexDirection: "column",
        gap: 12,
      },
      gameWrapper: {
        flex: 1,
        flexDirection: "column",
        gap: 12,
      },

      challegeMode: {
        flexDirection: "column",
        justifyContent: "space-evenly",
        gap: 30,
        marginBottom: 20,
      },
    },
    [DEVICE_SIZES.SM]: {
      container: {
        flex: 1,
        backgroundColor: AppColors.black_121212,
      },
      mainView: {
        flex: 1,
        paddingHorizontal: 16,
        marginHorizontal: 16,
      },
      divider: {
        height: 2,
        marginTop: 16,
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        width: "100%",
      },
      headerTitle: {
        color: AppColors.gray_C3C3C3,
        paddingTop: 16,
      },
      lableStyle: {
        color: AppColors.gray_C3C3C3,
        paddingTop: 14,
      },
      inputWrapper: {
        flex: 1,
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        paddingHorizontal: 12,
        borderRadius: 10,
      },
      textInputStyle: {
        paddingVertical: 18,
        paddingHorizontal: 10,
        color: AppColors.white,
      },
      leftWrapper: {
        width: "100%",
        flexDirection: "column",
        gap: 12,
      },
      rightWrapper: {
        width: "100%",
        flexDirection: "column",
        gap: 12,
      },
      dropDownStyle: {
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        borderColor: AppColors.appGrayColor_1C1C1C,
        paddingVertical: 18,
        color: AppColors.white,
      },
      mainInputWrapper: {
        flexDirection: "column",
        gap: 20,
      },
      rightDurationWrapper: {
        width: "20%",
        flexDirection: "column",
        gap: 12,
      },
      gameWrapper: {
        width: "40%",
        flexDirection: "column",
        gap: 12,
      },

      challegeMode: {
        flexDirection: "column",
        justifyContent: "space-evenly",
        gap: 30,
        marginBottom: 20,
      },
      dragDropView: { flexDirection: "column" },
      viewStyle: {
        width: "47%",
      },
    },
    [DEVICE_SIZES.XS]: {
      viewStyle: {
        width: "47%",
      },
      container: {
        flex: 1,
        backgroundColor: AppColors.black_121212,
      },
      mainView: {
        flex: 1,
        paddingHorizontal: 0,
      },
      divider: {
        height: 2,
        marginTop: 16,
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        width: "100%",
      },
      headerTitle: {
        color: AppColors.gray_C3C3C3,
        paddingTop: 16,
      },
      lableStyle: {
        color: AppColors.gray_C3C3C3,
        paddingTop: 14,
      },
      inputWrapper: {
        flex: 1,
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        paddingHorizontal: 12,
        borderRadius: 10,
      },
      textInputStyle: {
        paddingVertical: 18,
        paddingHorizontal: 10,
        color: AppColors.white,
      },
      leftWrapper: {
        width: "100%",
        flexDirection: "column",
        gap: 12,
      },
      rightWrapper: {
        width: "100%",

        flexDirection: "column",
        gap: 12,
      },
      dropDownStyle: {
        backgroundColor: AppColors.appGrayColor_1C1C1C,
        borderColor: AppColors.appGrayColor_1C1C1C,
        paddingVertical: 18,
        color: AppColors.white,
      },
      mainInputWrapper: {
        flexDirection: "column",
        gap: 20,
      },
      rightDurationWrapper: {
        width: "100%",
        flexDirection: "column",
        gap: 12,
      },
      gameWrapper: {
        width: "100%",
        flexDirection: "column",
        gap: 12,
      },

      challegeMode: {
        flexDirection: "column",
        justifyContent: "space-evenly",
        gap: 30,
        marginBottom: 20,
      },
      dragDropView: { flexDirection: "column" },
    },
  }
);
